import React, { PureComponent } from 'react';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { object } from '@philips-emr/tws-core/lib/component/prop-types';

import { HpmsTextHtmlAPI } from '../../api';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsTextHtmlAPI })
export default class HpmsTextHtml extends PureComponent {

  static propTypes = {
    data: object.notEnumerable(),
  }

  render() {
    return (
      <div className="c-text-html__value">
        <div className="c-text-html__value--width"
          dangerouslySetInnerHTML={{ __html: this.props.data }}></div>
      </div>
    );
  }
}
